import { createFileRoute } from '@tanstack/react-router';

import CheckoutReturn from '@/components/_checkout/CheckoutReturn.tsx';
import { CardLayout } from '@/components/layouts/index.tsx';

const PaymentPage = () => <CheckoutReturn action="success" />;

export const Route = createFileRoute('/checkout/success')({
  component: () => (
    <CardLayout title="shared.navigation.checkout">
      <PaymentPage />
    </CardLayout>
  ),
});
